import React, { useEffect, useState, useRef } from "react";
import "../css-coding/ClientSectionD.css";

import avatar1 from "../assets/avatar1.png";
import avatar2 from "../assets/avatar2.jpg";
import avatar3 from "../assets/avatar3.png";
import avatar4 from "../assets/avatar4.png";
import avatar5 from "../assets/avatar5.png";
import avatar6 from "../assets/avatar6.png";
import avatar7 from "../assets/avatar7.jpg";
import avatar8 from "../assets/avatar8.png";
import avatar9 from "../assets/avatar9.png";
import avatar10 from "../assets/avatar10.png";
import avatar11 from "../assets/avatar11.png";

import footerImage from "../assets/Profile.jpg";

const allaAvatars = [
  avatar1, avatar2, avatar11, avatar4, avatar5,
  avatar6, avatar3, avatar8, avatar9, avatar10,
  avatar3, avatar8, avatar9, avatar7, avatar4,
  avatar5, avatar10,
];

// const allaAvatars = [
//   avatar1, avatar2, avatar3, avatar4, avatar5,
//   avatar6, avatar7, avatar8, avatar9, avatar10,
//   avatar11, avatar1, avatar2, avatar3, avatar4,
//   avatar5, avatar6,
// ];

const ClientSection = () => {
  const [rotation, setRotation] = useState(0);
  const targetRotation = useRef(0);
  const [ctaHover, setCtaHover] = useState(false);

  const [wrapperWidth, setWrapperWidth] = useState(
    window.innerWidth <= 1024 ? 700 : 1000
  );

  useEffect(() => {
    const updateSize = () => {
      setWrapperWidth(window.innerWidth <= 1024 ? 700 : 1000);
    };

    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  // Smooth rotation
  useEffect(() => {
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      const delta = window.scrollY - lastScrollY;
      lastScrollY = window.scrollY;
      targetRotation.current += delta * 0.1;
    };

    const smoothAnimation = () => {
      setRotation(prev => prev + (targetRotation.current - prev) * 0.015);
      requestAnimationFrame(smoothAnimation);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    smoothAnimation();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const radius = wrapperWidth / 2 - 60;
  const angleStep = 360 / allaAvatars.length;

  return (
    <div className="gs-section">
      <div
        className="gs-arc-wrapper"
        style={{
          width: `${wrapperWidth}px`,
          height: `${wrapperWidth / 2}px`,
        }}
      >
        {allaAvatars.map((img, i) => {
          const baseAngle = angleStep * i + rotation;
          const theta = (baseAngle * Math.PI) / 180;

          const x = radius * Math.cos(theta);
          const y = -radius * Math.sin(theta);

          return (
            <div
              key={i}
              className="gs-avatar"
              style={{
                backgroundImage: `url(${img})`,
                left: `calc(50% + ${x}px)`,
                top: `calc(100% + ${y}px)`,
              }}
            />
          );
        })}
      </div>

      <div className="gs-center-content">
        <h2>
            <b>
          100+ clients get better videos, faster, because when</b> <span className="italic">quality</span>{" "}
          <b>matters, they trust <br/> The Growth Secret!</b>
        </h2>

        {/* <div
          className="gs-cta-box"
          onMouseEnter={() => setCtaHover(true)}
          onMouseLeave={() => setCtaHover(false)}
        >
          <img src={ctaAvatar} className="gs-cta-avatar" />

          <div className="gs-cta-text-wrapper">
          
            <div
              className="gs-cta-content"
              style={{
                opacity: ctaHover ? 0 : 1,
                transform: ctaHover ? "translateY(-6px)" : "translateY(0)",
              }}
            >
              <div className="gs-cta-title">Book a 15-min intro call</div>
              <div className="gs-cta-status">
                <span className="gs-online-dot"></span> Available now
              </div>
            </div>

         
            <div
              className="gs-cta-hidden"
              style={{
                opacity: ctaHover ? 1 : 0,
                transform: ctaHover ? "translateY(0)" : "translateY(6px)",
              }}
            >
              <span style={{ fontWeight: 800 }}>Open Calendar</span>
            </div>
          </div> */}
        {/* </div> */}


         <a
            href="https://cal.com/itsprakashhere/30min"
            target="_blank"
            rel="noopener noreferrer"
            className="intro-call-gs"
          >
              <div className="cta-cc-button-gs">
            <img src={footerImage} alt="Agent" />
           
            <div className="button-text-wrapper-gs">
              <div className="default-text-gs">
                <strong>Book a 15-min intro call</strong>
                <br></br>
                <div className="online-gs"> 
                 <span className="dot-gs">🟢︎</span>

                 Available now</div>
              </div>
              <div className="hover-text-gs">
                <strong>Open Calendar</strong>
              </div>
            </div>
            </div>
          </a>
      </div>
    </div>
  );
};

export default ClientSection;
